export const CDNURL = 'https://cdn.ideacode.com.cn/';
export const LIVEURL = 'https://www.ideacode.com.cn/live/';
export const PROGRAMURL = 'https://www.ideacode.com.cn/';
